module.exports = __webpack_public_path__ + "static/img/03.ab5fa01e.png";